import { render, staticRenderFns } from "./EntrepreneurTitleTextCopy.vue?vue&type=template&id=1a794b7c&"
import script from "./EntrepreneurTitleTextCopy.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurTitleTextCopy.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurTitleTextCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports